import type {SitRouteWrapperProps} from "./SitRouteWrapper";
import {SitRouteWrapper} from "./SitRouteWrapper";
import {TargetTable} from "../pages/target/targetTable";
import {InitiativeTable} from "../pages/initiative/InitiativeTable";
import {InitiativeForm} from "../pages/initiative/forms/InitiativeForm";
import {TargetForm} from "../pages/target/forms/targetForm";
import {FinancialDashboard} from "../pages/financial-dashboard/financialDashboard";
import {IndicatorsDashboard} from "~/sit/pages/indicators-dashboard/IndicatorsDashboard.tsx";
import {PipelineDashboard} from "../pages/pipeline-dashboard/PipelineDashboard";
import {InitiativeApprovalDashboard} from "../pages/initiative/InitiativeApprovalDashboard";
import {CurrencyTable} from "../pages/settings/currency/CurrencyTable";
import {SitConfigForm} from "../pages/settings/config/SitConfigForm";
import type {RouteOptions, RouteSpecification} from "~/routing/routeClasses.ts";

type S = RouteSpecification<SitRouteWrapperProps>; //shortcut
type O = RouteOptions<SitRouteWrapperProps, unknown>; //shortcut

const sit: O = {wrapper: SitRouteWrapper, wProps: {}};

export const sitRoutePrefix = '/savings-tracker';

/**
 * All the URL names
 */
const r = {
    sit_home: sitRoutePrefix + '/initiatives',
    sit_initiatives: sitRoutePrefix + '/initiatives',
    sit_target: sitRoutePrefix + '/targets/:targetId',
    sit_targets: sitRoutePrefix + '/targets',
    sit_initiative: sitRoutePrefix + '/initiatives/:initiativeId/:approval?',
    sit_financial: sitRoutePrefix + '/financial-view',
    sit_indicators: sitRoutePrefix + '/indicators-dashboard',
    sit_pipeline_dashboard: sitRoutePrefix + '/pipeline-view',
    sit_approval: sitRoutePrefix + '/approval',
    sit_settings_conversion_rates: sitRoutePrefix + '/settings/currency',
    sit_settings_config: sitRoutePrefix + '/settings/configuration',
}

/**
 * The pages that link to the URLS
 */
export const sitRouteSpecifications: S[] = [
    [sit, r.sit_target, TargetForm],
    [sit, r.sit_targets, TargetTable],
    [sit, r.sit_initiative, InitiativeForm],
    [sit, r.sit_financial, FinancialDashboard],
    [sit, r.sit_indicators, IndicatorsDashboard],
    [sit, r.sit_pipeline_dashboard, PipelineDashboard],
    [sit, r.sit_approval, InitiativeApprovalDashboard],
    [sit, r.sit_settings_conversion_rates, CurrencyTable],
    [sit, r.sit_settings_config, SitConfigForm],
    [sit, r.sit_home, InitiativeTable],
];

export const sitRoutes = r;
